var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.ocr_templates") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "overflow-hidden" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { md: "12" } }, [
                  _c("div", { staticClass: "requestsList" }, [
                    _c(
                      "div",
                      { staticClass: "mt-0" },
                      [
                        _vm.activateSpinner
                          ? _c("spinner")
                          : _c(
                              "div",
                              { staticClass: "overflow-x-unset" },
                              [
                                _c(
                                  "f7-list",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      "f7-list-item",
                                      [
                                        _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "justify-content-start",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btnFilter",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.refreshInbox()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-rotate-right",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btnFilter_2",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.exportTemplates()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-upload",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "fab-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.extract_list"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.templatesList.length
                                  ? _c("b-table", {
                                      staticClass: "table mt-3 text-center",
                                      attrs: {
                                        responsive: "",
                                        hover: "",
                                        borderless: "",
                                        outlined: "",
                                        items: _vm.templatesList,
                                        fields: _vm.fields,
                                        "sort-by": _vm.sortField,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(active)",
                                            fn: function (data) {
                                              return [
                                                _vm._v(
                                                  _vm._s(data.value.active) +
                                                    "\n                    "
                                                ),
                                                data.value === "0"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-xmark btn btn-icon btn-icon-red",
                                                      }),
                                                    ])
                                                  : data.value === "1"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-warning btn btn-icon btn-icon-orange",
                                                      }),
                                                    ])
                                                  : data.value === "2"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-check btn btn-icon btn-icon-green",
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(id_account)",
                                            fn: function (data) {
                                              return [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-light fa-list",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.activateDetail(
                                                        data.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(edit)",
                                            fn: function (data) {
                                              return [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-light fa-pencil cursor",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.activateEdit(
                                                        data.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(delete)",
                                            fn: function (data) {
                                              return [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-light fa-trash",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.activateDelete(
                                                        data.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        249070194
                                      ),
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "noResult" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("common.no_result")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "justify-content-end mt-5" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mt-3",
                                        attrs: { lg: "2", offset: "7" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: { click: _vm.addTemplate },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-light fa-plus fs-17px",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.ocrtemplate_add"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }